exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".drag{margin:5px}.drop-allowed{background-color:rgba(0,255,0,.2)}.drop-forbidden{background-color:#d4d4d4}.drop-in{box-shadow:0 0 5px rgba(0,0,255,.4)}.drop-box{border:1px solid #000;min-height:50px;padding:20px}.formulas{width:100%;padding:10px;word-wrap:break-word;display:inline-block}.drag-component{position:absolute;background-color:#fff;top:0;width:calc(100% - 5px)}.dynamic-pricing-expert{overflow-y:scroll;height:890px;position:relative;overflow-x:hidden}.error{color:red}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-31c3757e!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/DynamicPricingRuleExpertComponent.vue
// module id = 865
// module chunks = 2